import styled from 'styled-components';
import { styledTheme } from 'common/theme';
interface OrderImageProps {
  isClickable?: boolean;
  customWidth?: string;
  customHeight?: string;
  marginLeft?: string;
}
export const OrdersContainer = styled.div`
  padding: 1.5rem 1.5rem 0;
  display: flex;
  flex-direction: column;
`;
export const OrderTableWrapper = styled.div`
  width: 100%;
  overflow-y: auto;
  margin-right: 1.5rem;
  .table-container-wrapper {
    height: calc(100vh - 35rem);
  }
`;
export const OrderMapWrapper = styled.div`
  width: 25%;
  height: 36.875rem;
`;
export const OrderModalFooter = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 0;
  margin: 0 2rem;
  border-top: 0.063rem solid ${styledTheme.colors.gray300};
`;
export const QuoteModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 1rem;
  align-items: center;
  padding: 1rem 0;
  margin: 0 2rem;
  border-top: 0.063rem solid ${styledTheme.colors.gray300};
`;
export const DetailTextLink = styled.a`
  text-decoration: none;
  color: ${styledTheme.colors.jbtBlue};
`;
export const OrderFooterTextWrapper = styled.div`
  margin-right: 2rem;
`;
export const ModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  button {
    margin-right: 1rem;
    width: max-content;
    white-space: nowrap;
  }
`;
export const SelectionHeader = styled.div`
  padding-left: 1rem;
  border-bottom: 0.063rem solid ${styledTheme.colors.darkBlue};
  font-weight: bold;
  font-size: 0.75rem;
  color: ${styledTheme.colors.darkBlue};
  padding-bottom: 1rem;
`;
export const SectionHeader = styled.div`
  display: flex;
  padding-left: 1rem;
  padding-bottom: 1rem;
`;
export const DetailTitleContainer = styled.div`
  width: 100%;
  padding: 1rem 0rem;
  background: ${styledTheme.colors.white};
  border-bottom: 1px solid ${styledTheme.colors.gray300};
`;
export const OrderIconContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
export const PurchaseOrder = styled.div`
  color: ${styledTheme.colors.jbtBlue};
  cursor: pointer;
  display: flex;
`;
export const OrderIconWrapper = styled.div<OrderImageProps>`
  width: ${(props) => (props.customWidth ? props.customWidth : '1rem')};
  height: ${(props) => (props.customHeight ? props.customHeight : '1rem')};
  float: left;
  margin-right: 0.5rem;
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '1.2rem')};
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
`;
export const OrderHeaderIconWrapper = styled.div<OrderImageProps>`
  width: ${(props) => (props.customWidth ? props.customWidth : '1rem')};
  height: ${(props) => (props.customHeight ? props.customHeight : '1rem')};
  float: left;
  margin-right: 0.5rem;
`;
export const QuoteHeaderIconWrapper = styled.div<OrderImageProps>`
  width: ${(props) => (props.customWidth ? props.customWidth : '1rem')};
  height: ${(props) => (props.customHeight ? props.customHeight : '1rem')};
`;
export const QuoteIconContainter = styled.div<OrderImageProps>`
  justify-content: center;
  align-items: center;
`;
export const SectionHeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  padding-right: 0.4rem;
`;
export const QuoteSupportHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
`;
export const QuoteSupporTitleContainer = styled.div`
  display: flex;
  margin-left: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const QuoteSupportPropmpt = styled.div`
  font-weight: 400;
  font-size: 0.75rem;
  margin-left: 0.5rem;
  color: ${styledTheme.colors.gray700};
`;
export const QuoteSupportContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  padding-left: 20px;
`;
export const QuoteSupportItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
`;
export const QuoteBUText = styled.div`
  color: ${styledTheme.colors.gray700};
  font-weight: 600;
  font-size: 0.875rem;
  margin-left: 0.5rem;
  text-wrap: wrap;
  word-wrap: break-word;
`;
export const QuoteSupportContactPhone = styled.div`
  color: ${styledTheme.colors.gray800};
  font-weight: 600;
  font-size: 0.75rem;
  margin-left: 0.5rem;
  text-wrap: wrap;
  word-wrap: break-word;
`;
export const QuoteSupportContactEmail = styled.div`
  color: ${styledTheme.colors.gray800};
  font-weight: 600;
  font-size: 0.7rem;
  margin-left: 0.5rem;
  text-wrap: wrap;
  word-wrap: break-word;
`;
export const QuoteText = styled.div`
  font-weight: 600;
  font-size: 1.17rem;
`;
export const RightColumnHeaderText = styled.div`
  font-weight: 600;
  font-size: 1rem;
  margin-left: 0.5rem;
`;
export const QuoteDataText = styled.div`
  display: flex;
  gap: 0.5rem;
`;
export const QuoteDataLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
`;
export const QuoteDataValue = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  color: ${styledTheme.colors.gray700};
`;
export const DetailsTableHeader = styled.div`
  margin-left: 1.2rem;
  margin-top: 0.8rem;
`;
export const POPrice = styled.div`
  width: 10rem;
  margin-right: 0.5rem;
  text-align: left;
  text-wrap: wrap;
  word-wrap: break-word;
`;
export const POPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
export const Status = styled.div<{ statusColor?: string }>`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${(props) =>
    props.statusColor === 'Expired'
      ? styledTheme.colors.red
      : props.statusColor === 'Pending'
      ? styledTheme.colors.darkBlue
      : props.statusColor === 'In progress'
      ? styledTheme.colors.orange
      : styledTheme.colors.green};
}`;
export const OrderIcon = styled.img`
  width: 100%;
`;
export const OrderModalBody = styled.div`
  overflow: auto;
  padding: 1rem 2rem;
  flex: 1;
  #pdf-download {
    display: none;
  }
`;
export const QuoteModalBody = styled.div`
  padding: 1rem 2rem;
  overflow: auto;
  flex: 1;
  #pdf-download {
    display: none;
  }
`;
export const OrderSupportColumn = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-wrap: wrap;
  padding: 1.5rem;
`;
export const QuoteSupportColumn = styled.div`
  position: relative;
  top: 10%;
  width: 20%;
  max-height: 25rem;
  display: flex;
  flex-direction: column;
  text-wrap: wrap;
  word-wrap: break-word;
  overflow: hidden;
  overflow-y: auto;
  border-left: 1px solid ${styledTheme.colors.gray300};
`;
export const OrderItemsContainer = styled.div`
  width: 75%;
  display: flex;
  flex-direction: column;
  margin-right: 2rem;
  margin-top: 1.2rem;
  border-top: 1px solid ${styledTheme.colors.gray700};
`;
export const QuoteItemsContainer = styled.div`
  margin-top: 0.8rem;
  border-top: 1px solid ${styledTheme.colors.gray300};
`;
export const QuoteListHeader = styled.div`
  margin-left: 1.2rem;
  margin-top: 0.8rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: rgba(48, 49, 50, 1);
`;
export const QuoteItemsWrapper = styled.div`
  width: 84%;
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
`;
export const AddressCardsContainer = styled.div`
  height: 30%;
  display: flex;
  flex-direction: row;
  border-right: 1px solid ${styledTheme.colors.gray700};
`;
export const POHeaderContainer = styled.div`
  height: 15%;
  display: flex;
  flex-direction: row;
  background-color: ${styledTheme.colors.gray200};
  border: 1px solid ${styledTheme.colors.gray700};
`;
export const POItemsTableContainer = styled.div`
  height: 40%;
  display: flex;
  flex-direction: column;
  border: 1px solid ${styledTheme.colors.gray700};
`;
export const POAddressCard = styled.div`
  width: 33.3%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${styledTheme.colors.gray700};
  border-left: 1px solid ${styledTheme.colors.gray700};
`;

export const POAddressText = styled.div`
  text-wrap: wrap;
  margin-left: 2.8rem;
  margin-top: -1rem;
  padding-right: 1rem;
  font-weight: 400;
  font-size: 0.726rem;
`;
export const POHeaderText = styled.div`
  text-wrap: wrap;
  margin-left: 2.8rem;
  margin-top: -1.2rem;
`;
export const POHeaderTextContainer = styled.div`
  margin-right: 2rem;
  margin-top: 0.7rem;
`;
export const POItemsTableWrapper = styled.div`
  position: relative;
  top: -1.2rem;
  overflow-y: auto;
`;
export const Totalbox = styled.div`
  margin-top: 0.525rem;
`;
export const TotalText = styled.div`
  float: right;
  font-weight: bold;
`;
